import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

import { LOCATION_CHANGE } from '../../utils/redux/location-reducer';

export const consts = createReqConsts('common', 'urlPreview', ['CLEAR']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'url_previews',
  type: 'post',
});

const requestReducer = createReqReducer(consts);

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case consts.CLEAR:
      return initialState;
    case LOCATION_CHANGE:
      return initialState;
    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/common/urlPreview.js